import CrmCenteredTitle from '../../../components/CrmCenteredTitle';
import React, { useState } from 'react';
import CrmLayout from '../../../components/CrmLayout';
import { useParams } from 'react-router-dom';
import { useMutation, useQuery } from '@apollo/client';
import { QUERY_CLIENT } from '../../../graphql/user';
import { Empty, Pagination } from 'antd';
import _ from 'lodash';
import { Comment } from './Comment';
import cls from './ClientComments.module.scss'
import { CommentSend } from './CommentSend';
import { MUTATION_DELETE_MESSAGE } from '../../../graphql/message';

export function ClientComments () {

    const { id } = useParams();
    const [page, setPage] = useState(1);
    const [deleteMessage] = useMutation(MUTATION_DELETE_MESSAGE)
    const query = useQuery(QUERY_CLIENT, {
        variables: {
            id: id,
            messages_sort: ['createdAt:DESC'],
            messages_pagination: {
                page: page,
                pageSize: 20,
            }
        },
    });

    const type = query.data?.usersPermissionsUser?.data?.attributes?.client?.data ? 'child' : 'parent';
    const client =
        query.data?.usersPermissionsUser?.data?.attributes?.client?.data ||
        query.data?.usersPermissionsUser?.data?.attributes?.parent?.data;
    const title = `${client?.attributes?.firstName} ${client?.attributes?.lastName}`;

    const onRemove = async (id) => {
        console.log('remove', id);
        await deleteMessage({
            variables: {
                id: id,
            },
            onCompleted: () => {
                query.refetch()
            }
        });
    }

    return (
        <CrmLayout>
            <CrmCenteredTitle title={`${title} – Комментарии`} />

            <div className={cls.blocks}>

                <CommentSend id={client?.id} onUpdate={() => query.refetch()} child={type === 'child'}/>

                {client?.attributes?.messages?.data?.length === 0 && (
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                )}

                {_.map(client?.attributes?.messages?.data, message => (
                <Comment
                    key={message.id}
                    createdAt={message.attributes.createdAt}
                    firstName={message.attributes.author?.data?.attributes?.firstName}
                    lastName={message.attributes.author?.data?.attributes?.lastName}
                    url={message.attributes.author?.data?.attributes?.avatar?.data?.attributes?.url}
                    color={message.attributes.author?.data?.attributes?.color}
                    message={message.attributes.message}
                    onRemove={() => onRemove(message.id)}
                />
            ))}
            </div>

            <Pagination
                className={'crm-task-pagination'}
                defaultCurrent={1}
                current={page}
                total={client?.attributes?.messages?.meta?.total}
                pageSize={20}
                onChange={(page) => {setPage(page)}}
            />
        </CrmLayout>
    )
}